/**
 * @param {string} key - The sessionStorage key to retrieve
 * @returns {Object} Parsed data object, or empty object if not found or parse error
 */
const getSessionData = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key) || '{}');
  } catch (e) {
    console.error(`Failed to read session storage for key: ${key}`, e);
    return {};
  }
};

/**
 * @param {string} key - The sessionStorage key to check
 * @param {string} scope - The scope within the key (e.g., product: 'reading' or 'lectura')
 */
export const hasSeenInSession = (key, scope) => {
  const seenData = getSessionData(key);
  return seenData[scope] === true;
};

/**
 * @param {string} key - The sessionStorage key to update
 * @param {string} scope - The scope within the key (e.g., product: 'reading' or 'lectura')
 */
export const markSeenInSession = (key, scope) => {
  try {
    const seenData = getSessionData(key);
    seenData[scope] = true;
    sessionStorage.setItem(key, JSON.stringify(seenData));
  } catch (e) {
    console.error(`Failed to write session storage for key: ${key}`, e);
  }
};
